import type { LegalContent } from "../content/types";

type LegalPageProps = {
  content: LegalContent;
};

function renderParagraph(text: string) {
  if (text === "axqora@gmail.com") {
    return (
      <a className="text-link" href="mailto:axqora@gmail.com">
        axqora@gmail.com
      </a>
    );
  }

  return text;
}

export function LegalPage({ content }: LegalPageProps) {
  return (
    <article className="legal-article">
      <h1>{content.title}</h1>
      <p className="legal-date">
        {content.lastUpdatedLabel}: {content.lastUpdated}
      </p>
      {content.sections.map((section) => (
        <section key={section.heading}>
          <h2>{section.heading}</h2>
          {section.body.map((paragraph) => (
            <p key={paragraph}>{renderParagraph(paragraph)}</p>
          ))}
        </section>
      ))}
    </article>
  );
}
